module.exports = __webpack_public_path__ + "static/media/ax.ef21fff0.svg";